<template>
  <main class="iphone overflow-hidden">
    <!-- This is only for building the iphone -->
    <section class="speaker absolute top-0 left-1/2 z-1" />

    <!-- This is only for building the iphone -->
    <section class="camera absolute top-0 z-1" />

    <!-- This is where we add the stashboard content -->
    <section class="content py-6 font-primary text-black overflow-hidden" v-dragscroll.y>
        <div class="flex flex-row flex-wrap justify-between">
          <div class="text-md pl-1.5">
            {{ stashboard.merchantName }}
          </div>
          <div v-if="stashboard.headers && stashboard.headers.length > 0" class="flex flex-row justify-start pr-1.5">
            <template v-for="(header, index) in stashboard.headers">
              <img :key="index" :src="header.attachment.resized_url" class="w-6 h-6 ml-1.5" title="stashboard header image" />
            </template>
          </div>
        </div>

        <template v-if="isContentEmpty">
          <div class="flex flex-col w-full h-full justify-center items-center text-center">
            <span class="w-1/3 text-2xl">no content available</span>
          </div>
        </template>

        <template v-else>
          <div v-if="urlImage" class="mt-2">
            <img :src="urlImage" class="w-full h-auto" title="stashboard image" />
          </div>

          <div v-if="stashboard.content" v-html="formattedContent" class="mt-3 text-center text-xs pointer-events-none"></div>

          <template v-if="stashboard.extension && stashboard.extension.type === 4">
            <div v-if="stashboard.extension.payload.length > 1" @click="seeButton = !seeButton" class="see-button cursor-pointer w-full text-right mt-2 text-sm">
              <template v-if="seeButton">see less</template>
              <template v-else>see all</template>
            </div>
            <div class="links-wrapper overflow-hidden" v-dragscroll.x>
              <div class="flex pt-3 pl-3 items-center" :class="{'flex-col justify-center': seeButton, 'flex-row justify-start': !seeButton}">
                <div class="link flex flex-row relative border border-solid rounded-lg mr-3.5 mb-3.5" v-for="(link, index) in stashboard.extension.payload" :key="index">
                  <div class="link-icon flex flex-row justify-center items-center absolute -left-1 -top-1 rounded-full">
                    <svg viewBox="0 0 512.092 512.092" class="w-1/2 h-auto">
                      <use xlink:href="#link-icon"></use>
                    </svg>
                  </div>
                  <div class="link-img grow">
                    <img :src="link.thumbnail ? cleanThumbnailUrl(link.thumbnail.url) : defaultThumbnailImage" :alt="link.title" class="link-img rounded-l-lg" />
                  </div>
                  <div class="link-detail block overflow-hidden text-left p-0.5 grow">
                    <span class="block text-xxs mb-0.5 leading-3 break-words">{{ link.title }}</span>
                    <span class="link-url block text-xxxs leading-3 break-words">{{ link.url }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="my-3 text-center">
              <span v-if="labelButton" class="border border-negative border-solid rounded-lg text-sm text-negative bg-white py-1 px-6">{{ labelButton }}</span>
            </div>
          </template>
        </template>
    </section>

    <!-- This is only for building the iphone -->
    <section class="power-button absolute top-20" />
  </main>
</template>

<script>
import linkifyHtml from 'linkifyjs/html';
import { dragscroll } from "vue-dragscroll";
import defaultThumbnailImage from 'stashboard/default_thumbnail_image.png';

export default {
  props: {
    stashboard: Object
  },

  name: "stashboard-preview",

  data() {
    return {
      defaultThumbnailImage,
      seeButton: false
    }
  },

  mounted(){
    const content = document.querySelector(".iphone .content");
    content.addEventListener("mousedown", () => {
      content.style.cursor = "grabbing";
    });
    content.addEventListener("mouseup", () => {
      content.style.cursor = "grab";
    })
  },

  computed: {
    isContentEmpty(){
      return !this.stashboard.image &&
             !this.stashboard.content &&
             !this.stashboard.extension
    },

    formattedContent(){
      const options = {
              nl2br: true
            },
            content = this.stashboard.content;

      return (content) ? linkifyHtml(content, options) : "";
    },

    labelButton(){
      const type = this.stashboard.extension?.type;
      let label = ""

      if(type === 3) label = "view wallet"
      else if(!type && this.stashboard.merchantWebsiteUrl) label = "shop online"
      else if(!!type) label = "view offer"

      return label
    },

    urlImage() {
      return this.stashboard.image?.url;
    }
  },

  methods: {
    cleanThumbnailUrl(url) {
      if(url.startsWith("http")) {
        return `${url}?h=50&w=75`;
      }
      return url;
    }
  },

  directives: {
    dragscroll
  }
}
</script>

<style lang="scss" scoped>
.iphone {
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0px 0px 0px 6px rgb(31, 31, 31),
              -5px -2px 5px 3px rgba(255, 255, 255, .45),
              5px 2px 5px 3px rgba(255, 255, 255, .45),
              0px 0px 0px 15px rgb(17, 17, 17);
  height: 500px;
  position: relative;
  width: 250px;

  .z-1 {
    z-index: 1;
  }

  &:before {
    background-color: rgb(31, 31, 31);
    border-radius: 0px 0px 15px 15px;
    content: "";
    height: 20px;
    left: 50%;
    position: absolute;
    top: 0px;
    transform: translateX(-50%);
    width: 60%;
    z-index: 1;
  }

  .speaker {
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset 0px -3px 3px 0px rgba(256, 256, 256, 0.2);
    height: 4px;
    transform: translate(-50%, 6px);
    width: 20%;
  }

  .camera {
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset 0px -3px 2px 0px rgba(256, 256, 256, 0.2);
    height: 8px;
    left: -7%;
    transform: translate(180px, 4px);
    width: 8px;

    &:after {
      background-color: #2d4d76;
      border-radius: 4px;
      box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
      content: '';
      display: block;
      height: 6px;
      left: 1px;
      position: absolute;
      top: 2px;
      width: 6px;
    }
  }

  .content {
    cursor: "grab";
    height:500px;
  }

  .links-wrapper {
    width: 250px;
  }

  .power-button {
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset -3px 0px 1px -1px rgba(255, 255, 255, .2);
    height: 50px;
    right: -19px;
    transform: translate(-50%, 0);
    width: 4px;
  }

  .see-button {
    color:#7c65f8;
  }

  .link {
    border-color:#7c65f8;
    height: 52px;
    width: 150px;
  }

  .link-icon {
    background-color: #7c65f8;
    height: 16px;
    width: 16px;

    svg {
      fill: #fff;
    }
  }

  .link-img {
    height: 50px;
    width: 75px;
  }

  .text-xxs {
    font-size: .55rem;
  }

  .text-xxxs {
    font-size: .35rem;
  }

  .link-detail {
    height: 50px;
    width: 64px;
  }

  .link-url {
    color: #c8ced3;
  }
}
</style>